import * as React from "react"
import { Flex, Box } from "@chakra-ui/react"
import { Outlet } from "react-router-dom"

export const AuthPage = () => {
  return (
    <Flex h="100vh" align="center" justify="center">
      <Box w={300}>
        <Outlet />
      </Box>
    </Flex>
  )
}
